export const productHeaderStandardGql = /* GraphQL */ `
... on landingPageContent2023_productHeaderStandard_BlockType {
    typeHandle
    theme
    alignment
    subtitle
    sectionTitle
    description
    mediaSize
    maxHeight
    links:lpProductHeaderStandardLinks {
        ... on lpProductHeaderStandardLinks_BlockType {
            linkStyle:lpProductHeaderStandardLinkStyle
            enableModal:lpProductHeaderStandardEnableModal
            disclaimerFootnote:lpProductHeaderStandardDisclaimerFootnote {
                ... on disclaimerFootnote_disclaimerFootnote_Entry {
                    content:disclaimercontent
                }
            }
            link:lpProductHeaderStandardLink {
                ariaLabel
                customText
                url
                target
                text
                element {
                    title
                    ... on videos_Asset {
                        videoId
                        videoSource
                    }
                    ... on videoUploads_Asset {
                        videoUrl:url
                    }
                }
            }
        }
    }
    media {
        ... on images_Asset {
            title
            uncropped1920w {
                srcset
                srcWebp
            }
        }
    }
}`;
